export const defaultSteps = [
  "Choose Blueprint",
  "Customize Blueprint",
  "Apply Policy",
];
